import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type BackOfficeSessionContextValue = {
  dismissedMonthlyTargetModal: boolean;
  dismissMonthlyTargetModal: () => void;
  resetMonthlyTargetModalDismissal: () => void;
};

const BackOfficeSessionContext = createContext<
  BackOfficeSessionContextValue | undefined
>(undefined);

export const useBackOfficeSession = (): BackOfficeSessionContextValue => {
  const ctx = useContext(BackOfficeSessionContext);
  if (!ctx) {
    throw new Error(
      'useBackOfficeSession must be used within BackOfficeSessionProvider',
    );
  }
  return ctx;
};

export const BackOfficeSessionProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [dismissedMonthlyTargetModal, setDismissedMonthlyTargetModal] =
    useState(false);

  const dismissMonthlyTargetModal = useCallback(() => {
    setDismissedMonthlyTargetModal(true);
  }, []);

  const resetMonthlyTargetModalDismissal = useCallback(() => {
    setDismissedMonthlyTargetModal(false);
  }, []);

  const value = useMemo(
    () => ({
      dismissedMonthlyTargetModal,
      dismissMonthlyTargetModal,
      resetMonthlyTargetModalDismissal,
    }),
    [
      dismissedMonthlyTargetModal,
      dismissMonthlyTargetModal,
      resetMonthlyTargetModalDismissal,
    ],
  );

  return (
    <BackOfficeSessionContext.Provider value={value}>
      {children}
    </BackOfficeSessionContext.Provider>
  );
};

export default BackOfficeSessionContext;
